var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512",
    id: "facebook",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 67.83,
    x2: 474.19,
    y1: 82.42,
    y2: 389.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b5f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#178cc8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M256 0c141.39,0 256,114.61 256,256 0,141.39 -114.61,256 -256,256 -141.39,0 -256,-114.61 -256,-256 0,-141.39 114.61,-256 256,-256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M219.17 394.15c0,1.97 1.6,3.57 3.57,3.57l50.9 0c1.97,0 3.56,-1.6 3.56,-3.57l0 -139.27 36.9 0c1.85,0 3.4,-1.42 3.55,-3.27l3.55 -41.96c0.18,-2.08 -1.46,-3.87 -3.55,-3.87l-40.45 0 0 -29.77c0,-6.98 5.66,-12.63 12.64,-12.63l28.43 0c1.98,0 3.57,-1.6 3.57,-3.57l0 -41.97c0,-1.97 -1.59,-3.57 -3.57,-3.57l-48.04 0c-28.2,0 -51.06,22.86 -51.06,51.05l0 40.46 -25.44 0c-1.97,0 -3.57,1.6 -3.57,3.57l0 41.96c0,1.98 1.6,3.57 3.57,3.57l25.44 0 0 139.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook (1).5462f609adf458ba7e935c961fc917ff.svg";
export { ForwardRef as ReactComponent };